/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React from "react";
import "../terms-of-service.scss";

const TOS = () => {
  return (
    <div>
      <p
        style={{
          marginRight: "-.35pt",
          marginLeft: "0in",
          fontSize: 13,
          fontFamily: '"Arial","sans-serif"',
          marginTop: "0in",
          marginBottom: "6.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          This Drayage Agreement (this “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Agreement
          </strong>
          ”) is entered into as of{" "}
          <span style={{ background: "yellow" }}>_____________,</span> 2023 (the
          “<strong>Effective Date</strong>”) by and between KlearNow, Corp., a
          Delaware corporation (“<strong>KN</strong>”), and [
          <span style={{ background: "yellow" }}>Name of Trucking Company</span>
          ] (“
          <strong>Service Provider</strong>”). KN and Service Provider shall
          sometimes collectively be referred to herein as the “
          <strong>Parties</strong>” or, individually, as a “
          <strong>Party</strong>”.
        </span>
      </p>
      <div
        style={{
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "120%",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
        }}
      >
        <ol
          style={{
            marginBottom: "0in",
            listStyleType: "decimal",
            marginLeft: "-0.5in",
          }}
        >
          <li
            style={{
              margin: "0in",
              marginBottom: ".0001pt",
              lineHeight: "120%",
              fontSize: 11,
              fontFamily: '"Verdana","sans-serif"',
            }}
          >
            <span
              style={{
                fontFamily: '"Calibri","sans-serif"',
                fontSize: "11.0pt",
              }}
            >
              DEFINITIONS
            </span>
          </li>
        </ol>
      </div>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span
          style={{
            fontSize: 15,
            fontFamily: '"Calibri","sans-serif"',
            color: "black",
          }}
        >
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Affiliate
          </strong>
          ” shall mean, with respect to any Person, any other Person that,
          directly or indirectly, through one or more intermediaries, controls,
          is controlled by, or is under common control with, such Person, and
          for such purposes, the term “<strong>control</strong>” (including the
          terms “<strong>controlled by</strong>” and “
          <strong>under common control with</strong>”) shall mean the
          possession, directly or indirectly, of the power to direct or cause
          the direction of the management and policies of such Person, whether
          through ownership of voting securities, by contract or otherwise;
          provided that direct or indirect ownership of equity of a Person
          carrying more than fifty percent (50%) of the voting rights shall be
          considered control of that Person, notwithstanding that control in
          fact may be exercised by another Person or group of Persons.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span
          style={{
            fontSize: 15,
            fontFamily: '"Calibri","sans-serif"',
            color: "black",
          }}
        >
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Confidential Information
          </strong>
        </span>
        <span
          style={{
            fontSize: 15,
            fontFamily: '"Calibri","sans-serif"',
            color: "black",
          }}
        >
          " refers to
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          non-public information that either Party may obtain from the other or
          have access to by virtue of this Agreement, including, but not limited
          to, each Party’s data and each Party’s proprietary software and
          computer operations, all code, inventions, algorithms, business
          concepts, workflow, marketing, financial, business and technical
          information, the terms and pricing under this Agreement,
          authentication credentials associated with the use of the Platform,
          Personal Information of any natural person, and all other information
          identified or reasonably expected to be regarded by the other Party as
          confidential.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
          <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
            “Contact”
          </span>
        </strong>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          means any contact through any means (electronic, email, telephone,
          text, etc.) between an End User and
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          Service Provider
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          through the Platform; provided, however, that in all cases the
          determination of whether a Contact has occurred shall be determined by
          KN in its sole and absolute discretion.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
          <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
            “Content”
          </span>
        </strong>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          means information, software, applications, online services, features,
          technology, data, text, audio, video, images
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          , resources, documentation, code, tools, tool kits,
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          or other content.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Country Addendum
          </strong>
          ” means the addendum containing jurisdictional specific terms,
          conditions and exceptions, which may apply to Service Providers that
          are domiciled outside of the United States, and which can be found at{" "}
          <span style={{ background: "yellow" }}>[INSERT LINK]</span>, as may be
          updated from time to time.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span
          style={{
            fontSize: 15,
            fontFamily: '"Calibri","sans-serif"',
            color: "black",
          }}
        >
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            End
          </strong>
        </span>
        <strong>
          <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
            User
          </span>
        </strong>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          ” means a Person authorized by KN to use the Content, the Exchange or
          any services provided by KN to locate information about trucking
          companies and other drayage providers, including Service Provider.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Exchange
          </strong>
          ” means KN’s online, web-based directory and marketplace available as
          part of the Platform whereby End Users can obtain information about
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          Service Providers
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          who, in turn, may be engaged by End Users to perform Services.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Intellectual Property
          </strong>
          ” means any patents, patent rights, design rights, copyrights,
          database rights, trade secrets, know-how, trademarks, trade names,
          service marks and other intellectual property embodied therein and all
          applications and rights to apply for registration or protection rights
          pertaining thereto, in existence at the date hereof or created in the
          future.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            KN’s Marks
          </strong>
          ” means the KlearNow, Corp. company name and any other marks or logos
          associated with KN or its Affiliates.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Person
          </strong>
          ” shall mean any individual, general partnership (including limited
          liability partnerships), limited partnership, limited liability
          company, corporation, joint venture, trust, business trust,
          cooperative, association or other business organization, whether
          domestic or foreign, trustee, or any agencies, authorities, bodies,
          boards, commissions, courts, instrumentalities, legislatures and
          offices of any nature whatsoever, foreign or domestic, of any federal,
          state, county, district, municipal, city or other political
          subdivision.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Platform
          </strong>
          ” means KN’s website, applications and technology platform (including
          the Exchange).
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Services
          </strong>
          ” means trucking, transportation, drayage, and related services to be
          provided by a
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          Service Provider
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          to an End User following any Contact.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          margin: "0in",
          marginBottom: "4.0pt",
          lineHeight: "normal",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Service Provider Data
          </strong>
          ” means all electronic data or information submitted or generated by
          Service Provider through the use of the Platform.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Service Provider’s Marks
          </strong>
          ” means Service Provider’s company name and any other marks or logos
          associated with
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          Service Provider
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          or otherwise used by
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          Service Provider
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          or its Affiliates in the ordinary course of their respective
          businesses.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          “
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Taxes
          </strong>
          ” means all applicable taxes, including, without limitation, sales or
          use taxes, transaction privilege taxes, excise tax, value added tax,
          gross receipts taxes and other charges such as duties, customs,
          tariffs, imposts and government-imposed surcharges.
        </span>
      </p>
      <div
        style={{
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "120%",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
        }}
      >
        <ol
          style={{
            marginBottom: "0in",
            listStyleType: "undefined",
            marginLeft: "-0.5in",
          }}
        >
          <li
            style={{
              margin: "0in",
              marginBottom: ".0001pt",
              lineHeight: "120%",
              fontSize: 11,
              fontFamily: '"Verdana","sans-serif"',
            }}
          >
            <span
              style={{
                fontFamily: '"Calibri","sans-serif"',
                fontSize: "11.0pt",
              }}
            >
              Pricing
            </span>
          </li>
        </ol>
      </div>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 16,
          fontFamily: '"Times New Roman","serif"',
          margin: "0in",
          marginBottom: ".0001pt",
        }}
      >
        <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
          <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
            Pricing
          </span>
        </strong>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          . KN will collect fees (“
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            Service Fees
          </strong>
          ”) from End Users through the Exchange for each shipment processed by
          Service Provider following any Contact between Service Provider and an
          End User through the Exchange. KN will transmit to Service Provider
          the agreed rate (as noted via respective email or on the platform) for
          each Service and or Fee actually received by KN in consideration for
          Service Provider’s performance of Services with respect to the
          applicable shipment in accordance with Section 2.2 (the “
          <strong>Service Provider’s Fees</strong>”). Base Rate Approvals
          submitted by carrier are honored until considered cancelled or
          expired. Any and all changes must have written approval from Klearnow.
          Accessorial Charges are considered current and valid until amended or
          expired. Any and all changes from have written approval from Klearnow.
          Service Provider shall not collect fees directly from any End User
          with respect to the Services and shall not solicit any End User to pay
          any other fees or compensation, other than the fees and compensation
          that will be collected by KN through the Exchange. Violation of this
          Section 2.1 is deemed to be a material breach of this Agreement and
          grounds for KN to immediately terminate this Agreement and revoke
          Service Provider’s access to the Platform.
        </span>
      </p>
      <div
        style={{
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "120%",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
        }}
      >
        <ol style={{ marginBottom: "0in", listStyleType: "undefined" }}>
          <li
            style={{
              margin: "0in",
              marginBottom: ".0001pt",
              lineHeight: "120%",
              fontSize: 11,
              fontFamily: '"Verdana","sans-serif"',
            }}
          >
            <strong>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Payment; Records; Taxes.
              </span>
            </strong>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              KN shall transmit Service Provider’s Fees on a weekly basis with
              respect to all Service Fees actually collected by KN with respect
              to Services performed by
            </span>
            <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              during the immediately preceding calendar week. KN will use
              commercially reasonable efforts to transmit
            </span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Service Provider’s
            </span>
            <span style={{ fontSize: "11.0pt" }}>Fees to the</span>
            <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              on the third business day of each calendar week (i.e., generally
              Wednesday unless Monday and/or Tuesday is a federal holiday or
              otherwise not a business day) for all Service Fees actually
              received by KN prior to 5pm (Pacific Time) on the last business
              day of the preceding calendar week (i.e., Friday, unless Friday is
              a federal holiday or otherwise not a business day); provided,
              however that, for the avoidance of doubt, interest shall not
              accrue with respect to any
            </span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Service Provider’s
            </span>
            <span style={{ fontSize: "11.0pt" }}>
              Fees prior to payment thereof to
            </span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Service Provider
            </span>
            <span
              style={{
                fontFamily: '"Calibri","sans-serif"',
                fontSize: "11.0pt",
              }}
            >
              and KN shall not be liable for any losses or damages that may
              result in any delay in transmission of the Service Provider’s Fees
              (except in the case of fraud or bad faith on the part of KN).
            </span>
            <span
              style={{
                fontFamily: '"Calibri","sans-serif"',
                fontSize: "11.0pt",
              }}
            >
              KN agrees to maintain reasonable records for at least six (6)
              months backwards at any point in time with respect to the
            </span>
            <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Fees. KN shall permit
            </span>
            <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              to reasonably inspect and audit KN’s records pertaining to the
            </span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Service Provider’s
            </span>
            <span style={{ fontSize: "11.0pt" }}>
              Fees. Any such inspection and audit shall be paid for by
            </span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Service Provider
            </span>
            <span
              style={{
                fontFamily: '"Calibri","sans-serif"',
                fontSize: "11.0pt",
              }}
            >
              , unless such inspection or audit reveals an error in excess of
              $10,000, in which case, the costs and expenses of such inspection
              and audit shall be paid for by KN. Any such inspection and audit
              shall be conducted no more than once per year during regular
              business hours, with reasonable advance notice, in a manner not to
              interfere unduly with normal activities of KN.
            </span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Service Provider’s
            </span>
            <span style={{ fontSize: "11.0pt" }}>
              Fees described above are exclusive of all applicable Taxes, which
              shall be paid separately by
            </span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Service Provider
            </span>
            <span style={{ fontSize: "11.0pt" }}>. </span>
          </li>
        </ol>
      </div>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "8.0pt",
          marginBottom: "4.0pt",
          textAlign: "justify",
          textIndent: "0in",
          fontWeight: "bold",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          Except as expressly set forth in this Agreement, no additional
          compensation, transaction, subscription or other fees whatsoever will
          be owed by one Party to the other Party in connection with the sale
          and distribution of SERVICE PROVIDER’S SERVICES. Each Party is solely
          responsible and liable for all costs and expenses incurred in
          performing its obligations under this Agreement.
        </span>
      </p>
      <ol
        className="decimal_type"
        style={{ listStyleType: "undefined", marginLeft: "-0.5in" }}
      >
        <li>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Restrictions on use
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Service Provider Information Approval Process
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . Service Provider shall submit information regarding Service
                Provider and the Services offered by Service Provider to KN for
                its review and approval for listing on the Exchange.
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                KN reserves the right, in its sole discretion and for any reason
                at any time, to refuse approval of any information submitted by
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                and/or to remove all information regarding
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                from the Exchange. KN may adopt any review standards, policies
                and practices with respect to the evaluation and approval of
                information regarding custom brokers and End Users that is
                included on the Exchange, and may change such standards,
                policies and practices, in its sole discretion.
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                shall comply with all such policies and practices. KN reserves
                the right to re-evaluate any previously-approved Service
                Provider information set forth on the Exchange in connection
                with updates to its review and approval standards, policies and
                practices. KN’s approval of information regarding
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                for listing on the Exchange shall not be deemed an endorsement
                by KN of the
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider
              </span>
              <span style={{ fontSize: "11.0pt" }}>or of</span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Content, products or services.
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                acknowledges that
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                is solely responsible for, and that KN has no responsibility or
                liability whatsoever for, the performance of
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                services to End Users or for any interaction between
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                and any End User.
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                further represents that Service Provider shall be solely
                responsible for the accuracy, legality, and appropriateness of
                any Content or information
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                submits to KN, or makes available on or through, the Exchange.
                Without limiting the generality of the foregoing,
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                agrees to maintain all licenses and permits required by
                applicable law in order to perform services on behalf of End
                Users and agrees that all information regarding its licensure
                and permits set forth on the Exchange is, and shall at all times
                be, true and correct in all respects.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Service Provider’s Access
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . KN may terminate this Agreement and suspend Service Provider’s
                access to the Exchange for any reason or for no reason. Service
                Provider is responsible for all activities that occur between
                Service Provider and End User. Service Provider shall at all
                times during the term of this Agreement comply with all
                applicable laws.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Restrictions on Use
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . Unless otherwise authorized under this Agreement, Service
                Provider may not and will not allow any third party to:{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (i)
                </strong>{" "}
                exploit or cause the exploitation of the Exchange or Content
                provided by KN in any unauthorized way, including but not
                limited to trespass, burdening network capacity or using the
                Exchange or KN’s Content other than for purposes authorized
                herein; <strong>(ii)</strong> sell, rent, lease, license,
                sublicense, distribute, make available, pledge, assign or
                otherwise transfer in whole or in part KN’s Content or access to
                the Exchange to another party; <strong>(iii)</strong> provide,
                disclose, divulge or make available to, or permit use of KN’s
                Content in whole or in part by any third party without KN’s
                prior written consent; <strong>(iv)</strong> modify, translate,
                adapt or create derivative works based on KN’s Content or the
                Exchange; <strong>(v)</strong>
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                decompile, disassemble or otherwise reverse engineer (except to
                the extent expressly permitted by applicable law,
                notwithstanding a contractual obligation to the contrary) the
                Platform (including the Exchange) or
              </span>
              <span style={{ fontSize: "11.0pt" }}>KN’s</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Content, or any portion thereof;
              </span>
              <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  (vi)
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                use the Platform or the Exchange in any way that is contrary to
                the terms and conditions of this Agreement;{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (vii)
                </strong>{" "}
                use the Platform or the Exchange to send or store any code,
                files, scripts, agents or programs intended to do harm,
                including, but not limited to, viruses, worms, time bombs and
                Trojan horses; <strong>(viii)</strong>use the Platform or the
                Exchange to store, publish or transmit infringing, libelous, or
                otherwise unlawful or tortious material, or to store, publish or
                transmit materials in violation of third party privacy or
                confidentiality rights; <strong>(ix)</strong> use the Platform
                or the Exchange in any way that violates the privacy rights of
                any End User or other Person; <strong>(x)</strong> use the
                Platform, the Exchange or any Content for any unlawful purposes;
                or <strong>(xi)</strong>
                share user IDs, passwords, or other account information with
                anyone other than
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider
              </span>
              <span style={{ fontSize: "11.0pt" }}>
                ’s authorized representatives.
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}></span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Contacts Outside the Exchange
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . If KN believes Service Provider is violating the policy on
                Contacts Outside the Exchange (considered if/when Carrier
                engages in a direct commercial relationship with customer or
                customers introduced on the platform for which they had no
                previous relatioship), Service Provider may be subject to a
                range of actions, including limits on Service Provider’s
                privileges to use the Platform and the Exchange, restrictions on
                listings and account features, suspension of Service Provider’s
                account, application of fees, and recovery of expenses for
                policy monitoring and enforcement. In addition, Service
                Provider’s violation of this Section 3.4 and/or the policy on
                Contacts Outside the Exchange would cause KN significant harm.
                KN has devoted significant time and expense to develop and
                maintain the Platform and the Exchange and, therefore, Service
                Provider’s violation of Section 3.4 and/or the policy on
                Contracts Outside the Exchange would cause KN significant harm.
                Since the Parties agree it is impractical to calculate, or
                difficult to ascertain the actual damages resulting from a
                breach of the obligations in Section 3.4, if Service Provider
                breaches this Section 3.4 and/or the policy on Contacts Outside
                the Exchange (as determined by KN in its sole discretion), in
                addition to the other consequences and remedies set forth
                herein, Service Provider shall pay to KN an amount equal to
                $10,000 for each Contact between Service Provider and an End
                User that occurs outside the Exchange (i.e., without payment of
                a fee by End User to KN). The Parties hereby agree that the
                foregoing liquidated damage amount is a reasonable estimate of
                the actual damages KN may suffer as a result of each breach of
                this Section 3.4 and/or the policy on Contacts Outside the
                Exchange
              </span>
              <span style={{ fontSize: 15 }}>.</span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Service Provider Obligations
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>. </span>
              <ol
                className="decimal_type"
                style={{ listStyleType: "undefined" }}
              >
                <li>
                  <strong>
                    <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                      General Responsibilities
                    </span>
                  </strong>
                  <span style={{ fontSize: "11.0pt" }}>. Service Provider</span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    is responsible for{" "}
                    <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                      (i)
                    </strong>{" "}
                    uploading information regarding
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    Service Provider
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    to the Exchange once KN has approved such
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    information for uploading;{" "}
                    <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                      (ii)
                    </strong>{" "}
                    maintaining at all times a current privacy statement that is
                    available on Service Provider’s website which details KN’s
                    collection, processing, storage, handling and transmission
                    of End User’s data, including KN’s use, collection,
                    processing, storage, handling and transmission of such data;{" "}
                    <strong>(iii)</strong> providing Services and support to End
                    Users in a professional and workmanlike manner;{" "}
                    <strong>(iv)</strong> maintaining industry standard and
                    reasonable security mechanisms with respect to the issuance
                    of End User credentials and authentication necessary to
                    access the Services, and the protection of any other
                    personal information transmitted to or through, stored on,
                    published or otherwise made available to, or disseminated by
                    the
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    Service Provider
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    ;{" "}
                    <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                      (v)
                    </strong>{" "}
                    obtaining any necessary consents from End Users and any
                    other authorized third parties with respect to the
                    collection, processing, storage, handling and transmission
                    of their data or any other Confidential Information;{" "}
                    <strong>(vi)</strong>
                    using the Exchange only for the purposes set out in this
                    Agreement and any applicable laws, regulations or generally
                    accepted practices or guidelines; (<strong>vii</strong>)
                    using
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    Service Provider’s
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    reasonable best efforts to provide all Services to End Users
                    with utmost professionalism and completing all Services in
                    the manner agreed upon between End User and
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    ; (
                    <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                      viii
                    </strong>
                    ) resolving any and all disputes that may arise between End
                    User and Service Provider regarding any Services; and{" "}
                    <strong>(ix)</strong> maintaining all permits and licenses
                    required by
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    Service Provider
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    in order to provide the Services under applicable law and,
                    without limiting the generality of the foregoing, complying
                    with all applicable laws and regulations, including relevant
                    data privacy and data security laws.
                  </span>
                </li>
                <li>
                  <strong>
                    <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                      Listings
                    </span>
                  </strong>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    . Service Provider hereby grants KN a non-exclusive,
                    worldwide, fully paid-up, royalty-free license during the
                    term of this Agreement to list all information provided by
                    Service Provider regarding Service Provider (including the
                    Services it offers) on the Exchange and to market Service
                    Provider’s participation in the Exchange. Service Provider
                    may market the availability of its Services through the
                    Exchange, but it may not include the names of third parties
                    or third parties’ applications or other third party products
                    in the text of their own information included on the
                    Exchange without express authorization from the third party.
                  </span>
                </li>
                <li>
                  <strong>
                    <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                      Ratings.
                    </span>
                  </strong>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    KN may allow
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    End Users
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>
                    to rate and review Service Provider and the Services. KN is
                    also hereby authorized to collect and publish reviews and
                    usage data and metrics related to Service Provider and the
                    Services. Only
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    End Users
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    who make a bona fide Contact with a
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    Service Provider
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>
                    will be able to rate and review the
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    Service Provider
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    on the Exchange. Service Provider ratings may be used to
                    determine the placement of Service Provider on the Exchange.
                    KN reserves the right to display Service Provider to
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    End Users in the Platform
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  ></span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    in a manner that will be determined at KN’s sole discretion.
                    Without limiting the generality of the foregoing, KN may
                    list certain carriers and drayage service providers with
                    greater prominence than the Service Provider in exchange for
                    fees additional compensation paid by such other service
                    providers or based on a higher End User rating for such
                    other service providers. In addition, KN may include
                    advertisements on the Exchange (with placement of such
                    advertisements determined by KN in its sole and absolute
                    discretion), including in close proximity to information
                    about
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    Service Provider
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    set forth on the Exchange, in exchange for compensation.
                    Service Provider and the Services may be subject to
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    End User
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    ratings to which Service Provider may not agree. Service
                    Provider shall have no recourse whatsoever against KN or any
                    of its Affiliates in connection with End User ratings.
                  </span>
                </li>
                <li>
                  <strong>
                    <span
                      style={{
                        fontFamily: '"Calibri","sans-serif"',
                        fontSize: "11.0pt",
                      }}
                    >
                      End Users
                    </span>
                  </strong>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    .
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    Service Provider
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    is responsible for all interactions between
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    and End Users regarding the Services and for ensuring that
                    all Services are delivered in compliance with all applicable
                    laws.
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    Service Provider
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    may submit its terms and conditions for its Services to KN
                    for listing on the Exchange and require End Users to accept
                    such terms and conditions prior to accepting Services from
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    .
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}></span>
                  <span style={{ fontSize: "11.0pt" }}>
                    Service Provider’s terms and conditions shall be consistent
                    with the terms of this Agreement. If Service Provider
                    becomes aware of any violation of its obligations under this
                    Agreement by an
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    End User
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>
                    , Service Provider shall immediately inform KN so that KN
                    may investigate whether it is appropriate to suspend access
                    to and use of the Exchange by such
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    End User
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>
                    . KN will refer all customer service requests it receives
                    from
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    End Users
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    to Service Provider and Service Provider is responsible for
                    providing any customer service to
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    End Users who engage
                  </span>
                  <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    to provide Services
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    . KN does not provide any support services to
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    End Users
                  </span>
                  <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                    . Service Provider shall submit its terms and conditions for
                    KN’s review as part of the approval process, and any updates
                    must be submitted to KN for further approval. Service
                    Provider’s terms and conditions must not make any
                    representations or warranties about KN, the Exchange, the
                    Platform, any products or services of KN, or bind (or
                    purport to bind) KN in any way. All such terms and
                    conditions must provide that KN is a third party beneficiary
                    with respect to the enforcement of
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    End User’s
                  </span>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    use of the Exchange and the Services in compliance with the
                    requirements in this Agreement.
                  </span>
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            INTELLECTUAL PROPERTY RIGHTS, OWNERSHIP AND TITLE
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  KN’s Intellectual Property
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . Service Provider acknowledges and agrees that all Intellectual
                Property rights in and to the Exchange, the Platform and KN’s
                Content are owned by KN and shall, notwithstanding the terms of
                this Agreement, remain vested in KN. Unless otherwise expressly
                provided in this Agreement, Service Provider shall not acquire
                any proprietary right, title or interest in or to any
                Intellectual Property rights in KN’s Content, including the
                Platform or the Exchange. All rights not expressly granted by KN
                herein are reserved.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  KN Trademarks
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . KN’s Marks may not be used in any manner except as expressly
                permitted herein, unless as otherwise agreed in writing. Service
                Provider shall not bid on or purchase any keywords which are
                KN’s Marks in any keyword advertising service (i.e. Google
                Adwords) and Service Provider may not publish any advertisement
                that includes any of KN’s Marks without prior review and written
                approval of KN. All uses of KN’s Marks shall be in accordance
                with KN’s branding and trademark usage guidelines attached as{" "}
                <u>Exhibit A</u>, as may be updated by KN from time to time, and
                KN’s prior written approval. Subject to the foregoing and KN’s
                approval of any information regarding Service Provider for
                listing on the Exchange, KN grants to Service Provider during
                the term of this Agreement a limited,
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                non-exclusive, non-transferrable, non-sublicenseable,
                royalty-free license to use those of
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                KN’s
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Marks provided by
              </span>
              <span style={{ fontSize: "11.0pt" }}>KN</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>to</span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                for purposes of marketing its participation in the Exchange
                solely in connection with
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                exercising its rights and obligations under this Agreement in
                the territory approved by
              </span>
              <span style={{ fontSize: "11.0pt" }}>KN</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                in writing for such activities.
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                will not use
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                KN’s
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Marks in any manner that disparages, degrades, dilutes,
                tarnishes or otherwise reflects poorly on
              </span>
              <span style={{ fontSize: "11.0pt" }}>KN</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                or any of its products or services.
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                may revoke
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider’s
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                right to use
              </span>
              <span style={{ fontSize: "11.0pt" }}>KN’s</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Marks at any time upon written notice to
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                in its sole discretion.
              </span>
            </li>
            <li>
              <strong>
                <span
                  style={{
                    fontFamily: '"Calibri","sans-serif"',
                    fontSize: "11.0pt",
                  }}
                >
                  Service Provider Trademark License
                </span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>.</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                grants to
              </span>
              <span style={{ fontSize: "11.0pt" }}>KN</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                a non-exclusive, non-transferrable, non-sublicenseable,
                royalty-free license to use Service Provider’s Marks for the
                purpose of identifying and promoting
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                participation in KN’s programs (including the Exchange) and in
                connection with
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN’s</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                rights, duties and obligations under this Agreement.
              </span>
            </li>
            <li>
              <strong>
                <span
                  style={{
                    fontFamily: '"Calibri","sans-serif"',
                    fontSize: "11.0pt",
                  }}
                >
                  License to Use Suggestions.
                </span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}></span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                grants to
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                KN
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                and its Affiliates a worldwide, perpetual, irrevocable,
                royalty-free license to use and incorporate into the Platform
                and the Exchange any suggestion, enhancement request,
                recommendation, correction or other feedback provided by
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                or its affiliates and representatives relating to the Platform
                and the Exchange.
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              ></span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Data
                </span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                . KN shall own all Service Provider Data and may freely use all
                Service Provider Data in connection with the Platform and for
                all other lawful purposes.
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Notwithstanding anything herein to the contrary,
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                shall have the right to collect, store and analyze data and
                other information relating to the provision, use and performance
                of various aspects of the Platform, the Exchange and related
                systems and technologies (including, without limitation,
                information concerning
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Data), and
              </span>
              <span style={{ fontSize: "11.0pt" }}>KN</span>
              <span style={{ fontSize: "11.0pt" }}>
                will be free (during and after the term hereof) to use such
                information and data{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (i)
                </strong>{" "}
                to improve and enhance the Exchange and for other development,
                diagnostic and corrective purposes in connection with the
                Exchange and other
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                offerings, and{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (ii)
                </strong>{" "}
                for all other lawful purposes.
              </span>
            </li>
          </ol>
        </li>
        <li>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            CONFIDENTIALITY
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>Use and Disclosure</span>
              </strong>
              <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>.</span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                During this Agreement and following its termination,
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                each Party shall hold in confidence and not use for any purposes
                unrelated to this Agreement or disclose to any third party
                (except the Party’s employees, agents or contractors who are not
                competitors of KN and have a need to know and who are subject to
                confidentiality obligations at least as restrictive as those
                herein) any Confidential Information of the other Party, using
                the same degree of care that it uses to protect the
                confidentiality of its own confidential information of like kind
                (but in no event less than reasonable care). Each Party agrees
                to take all reasonable steps to ensure that the Confidential
                Information is not disclosed or distributed by its employees,
                contractors, or agents in violation of the terms of this
                Agreement.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>
                  Permitted Disclosures
                </span>
              </strong>
              <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>.</span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Either Party may disclose Confidential Information of the other
                Party either:{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (i)
                </strong>{" "}
                in response to a valid order by a court or other governmental or
                regulatory body, <strong>(ii)</strong> as otherwise required by
                law, <strong>(iii)</strong> as necessary to establish the rights
                of either Party under this Agreement, or <strong>(iv)</strong>
                following express written approval of the disclosing Party.
                Disclosing Party will promptly give notice to the receiving
                Party of any compelled disclosure and allow receiving Party to
                object or to seek a protective order, to the extent legally
                permitted
              </span>
              <span style={{ fontSize: "11.0pt" }}>.</span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>
                  Non-Confidential Information
                </span>
              </strong>
              <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>.</span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                The Parties shall not be obligated under this Section
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>5</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                (“Confidentiality”) with respect to Confidential Information
                that the receiving Party can demonstrate by contemporaneous
                written evidence:{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (i)
                </strong>
                is or becomes a part of the public domain through no act or
                omission of the receiving Party; <strong>(ii)</strong> was in
                the receiving Party’s lawful possession without restriction
                prior to the disclosure and had not been obtained by the
                receiving Party either directly or indirectly from the
                disclosing Party; <strong>(iii)</strong>is lawfully disclosed to
                the receiving Party by a third party without restriction on the
                disclosure; or <strong>(iv)</strong>is independently developed
                by the receiving Party without access to the Confidential
                Information.
              </span>
            </li>
          </ol>
        </li>
        <li>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            SECURITY AND DATA PROTECTION
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Service Provider’s Security and Redundancy.
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}></span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                KN recommends that
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                use strong security and redundancy features, such as access
                controls, encryption and backup.
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                is responsible for properly configuring and using the Content
                and the Exchange in a manner that provides security and
                redundancy of
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                account and any End User data, such as, for example, using
                enhanced access controls to prevent unauthorized access to
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                accounts, using encryption technology to prevent unauthorized
                access to or acquisition or disclosure of any personal
                information, and ensuring the appropriate level of backup to
                prevent loss of personal information. Service Provider shall
                comply and cooperate with KN in connection with any security
                testing KN requests. KN reserves the right to conduct its own
                independent security evaluation by itself or through a third
                party.
              </span>
            </li>
          </ol>
        </li>
        <li>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            TERM AND TERMINATION
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>Term of Agreement</span>
              </strong>
              <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>.</span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Unless earlier terminated pursuant Sections
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>7.2</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                (“Termination for Cause”) or
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>7.3</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                (“Termination for Insolvency”), this Agreement commences on the
                Effective Date and continues in force until terminated as set
                forth herein.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>
                  Termination for Cause
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . Either Party will have the right to terminate this Agreement
                immediately upon written notice at any time if the other Party
                is in material breach of any warranty, term, condition or
                covenant of this Agreement and fails to cure that breach within
                30 days after written notice of that breach.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>
                  Termination for Insolvency
                </span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                . Either Party may terminate the Agreement immediately if the
                other Party
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                becomes insolvent.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Termination for Convenience
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . Either Party may terminate this Agreement and
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider
              </span>
              <span style={{ fontSize: "11.0pt" }}>
                ’s participation in the Platform and the Exchange upon thirty
                (30) day’s written notice to the other Party for convenience,
                provided that
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}></span>
              <span style={{ fontSize: "11.0pt" }}>
                may not terminate this Agreement for convenience unless its
                terms and conditions allow for such termination without breach
                of any of
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider
              </span>
              <span style={{ fontSize: "11.0pt" }}>
                ’s obligations thereunder.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Effect of Termination
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . Upon termination, Service Provider’s account shall be
                automatically cancelled and thus
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider
              </span>
              <span style={{ fontSize: "11.0pt" }}>
                shall no longer have access to the Platform, the Exchange,
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN’s</span>
              <span style={{ fontSize: "11.0pt" }}>
                Content or its account, and all of
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider
              </span>
              <span style={{ fontSize: "11.0pt" }}>
                ’s right and licenses under this Agreement shall cease.
              </span>
            </li>
          </ol>
        </li>
        <li>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            WARRANTIES
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Service Provider Warranties.
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                Service Provider represents and warrants to
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                KN
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                that{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (i)
                </strong>
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                it has the full power to enter into this Agreement and to
                perform its obligations hereunder;
              </span>
              <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  (ii)
                </span>
              </strong>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                it has the right to grant the rights and licenses contemplated
                by this Agreement;{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (iii)
                </strong>{" "}
                it will comply with all applicable laws and regulations,
                including relevant data privacy and data security laws and all
                laws applicable to providers of trucking, drayage, and related
                services;
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              ></span>
              <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  (iv)
                </span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                it will not engage in any deceptive, misleading, illegal or
                unethical marketing activities, or activities that otherwise may
                be detrimental to
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                KN
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>or</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                End Users
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                ;{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (v)
                </strong>{" "}
                it has the right to provide the Service Provider Data to
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
              <span style={{ fontSize: "11.0pt" }}>
                ;{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (vi)
                </strong>
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN’s</span>
              <span style={{ fontSize: "11.0pt" }}>
                collection, processing, transfer, storage and/or use of the
                Service Provider Data or any other Confidential Information as
                provided in this Agreement will not infringe the Intellectual
                Property rights, privacy rights, publicity rights, or other
                legal rights of any third party;{" "}
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  (vii)
                </strong>{" "}
                it is a licensed motor carrier authorized to transport property
                and intermodal trailers/containers having prior or subsequent
                transport by rail, or ocean carrier under contracts with
                shippers and receivers and/or brokers of general commodities;{" "}
                <strong>(viii)</strong> it has executed valid interchange
                agreements with the UIIA or rail/ocean carrier(s) with whom
                intermodal transportation is arranged, and will provide KN with
                evidence of the agreement on request; <strong>(ix)</strong> it
                is not in default of any of its interchange agreement(s);{" "}
                <strong>(x)</strong>it has the expertise, qualified and trained
                personnel, proper equipment, and facilities to perform the
                Services for End Users; <strong>(xi)</strong>it is subject to
                agreements with owners and or lessors of equipment (“Equipment
                Agreements”) which may be used to perform its Services for End
                Users; <strong>(xii)</strong> it acknowledges that KN is not
                subject or party to any such Equipment Agreements, nor shall KN
                be liable for the operation, maintenance, or damage to any such
                equipment used by Service Provider; <strong>(xiii)</strong>it
                has and will maintain cargo, personal injury and public
                liability insurance as described below; <strong>(xiv)</strong>it
                will not insert, nor authorize any of its representatives or
                Affiliates to insert KN’s name on a bill of lading as the
                shipper without KN’s express written consent;{" "}
                <strong>(xv)</strong> insertion of KN’s name (but Service
                Provider or any of its representatives or Affiliates) as the
                carrier on a bill of lading shall be for Service Provider’s
                convenience only and shall not change KN’s status as owner and
                operator of the Exchange nor Service Provider’s status as a
                motor carrier; <strong>(xvi)</strong>it is in compliance with
                all applicable federal, state and local laws relating to the
                provision of the Services, including, but not limited to,
                applicable federal and state safety regulations;{" "}
                <strong>(xvii)</strong> it has implemented, maintains, and
                monitors equipment and driver safety control programs in
                compliance with all applicable laws and it maintains control of
                the means and method of transportation of goods including but
                limited to performance of its driver(s);{" "}
                <strong>(xviii)</strong>it will not re-broker, co-broker,
                subcontract, assign, interline, pass off, or hand off the
                transportation of shipments on behalf of End Users to any other
                persons or entity without prior written consent of KN;{" "}
                <strong>(xix)</strong>it is in, and shall maintain compliance
                during the term of this Agreement, with all applicable federal,
                state and local laws relating to the provision of its services
                including, but not limited to: transportation of Hazardous
                Materials (including the licensing and training of Haz-Mat
                qualified drivers), as defined in 49 C.F.R. §172.800, §173, and
                §397 et seq. to the extent that any shipments hereunder
                constitute Hazardous Materials, security regulations,
                owner/operator lease regulations, loading and securement of
                freight regulations, implementation and maintenance of driver
                safety regulations including, but not limited to, hiring,
                controlled substances and alcohol testing, and hours of service
                regulations; sanitation, temperature, and contamination
                requirements for transporting food, perishable, and other
                products, qualification and licensing and training of drivers,
                implementation and maintenance of equipment safety regulations,
                maintenance and control of the means and method of
                transportation including, but not limited to, performance of its
                drivers, and all applicable insurance laws and regulations
                including but not limited to workers’ compensation;{" "}
                <strong>(xx)</strong>all of its drivers shall be and are subject
                to the exclusive direction, control and supervision of Service
                Provider and not KN or End User, it being understood and agreed
                that in order to satisfy shipping requirements of End User’s
                customers and/or the contractual service obligations of End User
                or KN, any information furnished by any End User or KN to
                Service Provider verbally or in writing, including, but not
                limited to, routes, pick-up and delivery dates, and times,
                special handling requirements, bracing and blocking
                requirements, dimensions and weights are provided for
                informational purposes only and Service Provider assumes full
                responsibility for the performance of its drivers;{" "}
                <strong>(xxi)</strong>any communications or reporting
                requirements regarding the location of freight (tracing) are
                made in order to satisfy End User’s requirements or KN’s or End
                User’s contractual service obligations to its customers, it
                being understood and agreed that the method and manner of
                performance of the Services are the sole responsibility and
                control of Service Provider; <strong>(xxii)</strong>Service
                Provider will notify KN immediately if its federal operating
                authority is revoked, suspended or rendered inactive for any
                reason and/or if it is sold, or if there is a change in control
                of ownership, and/or any insurance required hereunder is
                threatened to be or is terminated, cancelled, suspended, or
                revoked for any reason; and <strong>(xxiii)</strong> it shall
                comply with all applicable laws and regulations relating to the
                transportation of Hazardous Materials as defined in 49 C.F.R.§
                172.800, §173, and §397, et seq. (including any amendments) to
                the extent that any shipments hereunder constitute Hazardous
                Materials.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>FMCSA Rating</span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                . Service Provider agrees that at no time during the term of
                this Agreement shall it have an “Unsatisfactory” or “Unfit” or
                an equivalent safety rating as determined by the Federal Motor
                Carrier Safety Administration (FMCSA), and that it has no
                knowledge of any threatened or pending interventions by FMCSA
                under CSA 2010; nor is it subject to any investigation or
                disciplinary action by any state agency related to enforcement
                of safety laws and regulations. If Service Provider receives an
                “Unsatisfactory” or “Unfit” safety rating, or a rating is
                changed from “Satisfactory” to “Conditional” or from “Continue
                to Operate” to “Marginal” it shall immediately notify KN and
                shall not transport any shipment for any End User without KN’s
                prior written consent. The provisions of this paragraph are
                intended to include safety rating designations which may replace
                those above, which are subject to change by FMCSA at any time.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>California Services</span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                . If transporting freight as an intrastate California motor
                carrier or into or out of the State of California as an
                interstate carrier, Service Provider agrees to utilize only CARB
                compliant equipment. Service Provider or its agent certifies
                that any equipment furnished will be incompliance with the
                in-use requirements of California’s regulations. Service
                Provider shall provide documentation for verification of
                compliance with CARB to KN on an annual basis. If transporting
                freight to/from the ocean ports in California, Service Provider
                shall comply with all statutes, regulations and court orders
                governing the Service Provider’s activities. If Service Provider
                is found in violation of California SB1402 Service Provider will
                immediately notify KN and agrees to indemnify, defend and hold
                harmless KN of any levies, fines, charges, interest and
                penalties brought against KN in connection with Service
                Provider’s failure to pay or for any non-compliance of any court
                order, judgement, administrative proceeding or
                arbitration/mediation settlement on any matter that is subject
                to SB1402.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  No bribery or corruption.
                </span>
              </strong>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                No payments or transfers of anything of value by Service
                Provider or its Affiliates or representatives shall be made
                which have the purpose or effect of bribery, acquiescence in
                extortion, kickbacks or any unlawful or improper means of
                obtaining business or any improper advantage.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  DISCLAIMER OF WARRANTIES
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . EXCEPT AS SET FORTH HEREIN, AND TO THE MAXIMUM EXTENT
                PERMITTED BY APPLICABLE LAW, KN PROVIDES THE content, THE
                PLATFORM, THE exchange and any services relating thereto “AS
                IS”, WITHOUT WARRANTY OF ANY KIND, INCLUDING BUT NOT LIMITED TO,
                EXPRESS OR IMPLIED or STATUTORY OR OTHER WARRANTIES OR
                CONDITIONS, INCLUDING WARRANTIES OF MERCHANTABILITY,
                SATISFACTORY QUALITY AND FITNESS FOR A PARTICULAR PURPOSE,
                NON-INFRINGEMENT, and those arising out of course of dealing,
                usage, or trade AND DOES NOT GUARANTEE THAT THE PLATFORM OR THE
                exchange WILL BE ERROR-FREE OR UNINTERRUPTED, or completely
                secure. SERVICE PROVIDER acknowledges that there are risks
                inherent in Internet connectivity that could result in the loss
                of SERVICE PROVIDER’s privacy, Confidential Information, SERVICE
                PROVIDER DATA and/or Content. KN has no obligation to provide
                security. SERVICE PROVIDER
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                shall have sole responsibility for the accuracy, quality,
                integrity, legality, reliability, appropriateness and ownership
                of all of
              </span>
              <span style={{ fontSize: "11.0pt" }}>SERVICE PROVIDER</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                DATA, Content and Applications.
              </span>
            </li>
          </ol>
        </li>
      </ol>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
        }}
      >
        <span
          style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
        ></span>
      </p>
      <ol
        className="decimal_type"
        style={{ listStyleType: "undefined", marginLeft: "-0.5in" }}
      >
        <li>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            service provider’s RESPONSIBILITIES
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>Equipment</span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . All shipments tendered by End User shall be accepted by
                Service Provider for transportation, provided such shipment does
                not exceed the capacity (weight or cubic volume) of Service
                Provider’s equipment. Service Provider agrees to provide or
                arrange for the “Necessary Equipment” and qualified personnel
                for completion of the Services. ”Necessary Equipment” means but
                is not limited to equipment which meets applicable state and
                federal safety and security standards, is structurally sound,
                and is suitable for transporting its contents without damage.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>Bills of Lading</span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                . Service Provider shall sign a bill of lading produced by
                shipper or Service Provider shall issue a bill of lading or
                delivery receipt for the property it receives and in compliance
                with 49 C.F.R. §373.101 (and any amendments thereto), for the
                property it receives for transportation on behalf of End Users.
                Unless otherwise agreed in writing, Service Provider shall
                become fully responsible/liable for the freight when it
                takes/receives possession thereof, and the
                trailer(s)/container(s) is loaded, regardless of whether a bill
                of lading has been issued, and/or signed, and/or delivered to
                Service Provider, and which responsibility/liability shall
                continue until delivery of the shipment to the consignee and the
                consignee signs the bill of lading or delivery receipt. Failure
                to issue a bill of lading, or sign a bill of lading
                acknowledging receipt of the cargo, by Service Provider, shall
                not affect the liability of Service Provider to KN and End
                Users. Service Provider shall submit copies of the railroad
                bills of lading or other proof of delivery to KN, as request by
                KN.
              </span>
              <span
                style={{ fontFamily: '"Calibri","sans-serif"', color: "black" }}
              ></span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Carrier shall provide "POD" Proof Of Delivery along with all
                supporting documents such as and not limited to. Pier Pass
                Receipts, Scale Tickets, in/Out Gate Receipts, Supporting
                documents that approve rate charges/increases, detention, and
                demurrage approvals and accessorials charges paid by carrier for
                reimbursement with appropriate approval in writing. Failure to
                submit backup within 35 days of empty ingate and/or final
                delivery will result in no compensation beyond base rate and FSC
                fees.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>
                  Loss and Damage Claims
                </span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>. </span>
              <ol
                className="decimal_type"
                style={{ listStyleType: "undefined" }}
              >
                <li>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    Service Provider shall comply with applicable federal and
                    state regulations (if any) for processing all loss and
                    damage claims and salvage, which arise out of the discharge
                    of the Services.
                  </span>
                </li>
                <li>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    The burden of proof for Service Provider’s liability and
                    damages for any cargo loss, or theft from any cause shall be
                    determined under the Carmack Amendment, 49 U.S.C.§14706.
                    Service Provider shall be liable for up to the full invoice
                    value of the goods while under its care, custody or control.
                  </span>
                </li>
                <li>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    Service Provider shall comply with 49 C.F.R. §370.1 et seq.
                    and any amendments and/or any other applicable regulations
                    issued or adopted by the Federal Motor Carrier Safety
                    Administration, U.S. Department of Transportation, for
                    processing all loss and damage claims and salvage, which
                    arise out of the discharge of the Services.
                  </span>
                </li>
                <li>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    When picking up a loaded container/trailer at a railroad
                    terminal, Service Provider shall inspect the
                    container/trailer for a seal. If there is no seal or the
                    seal is damaged or the seal number does not match the seal
                    number on the railroad interchange document, the driver
                    shall make a notation on the bill of lading and any other
                    interchange document and shall notify the applicable End
                    User immediately by telephone, fax or email. Service
                    Provider shall also notify the railroad gate personnel
                    immediately upon discover or a seal alteration, tampering,
                    or no seal.
                  </span>
                </li>
                <li>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    When delivering a loaded container/trailer to a consignee,
                    Service Provider shall write the trailer seal number on the
                    delivery receipt and mark it “seal intact” and obtain a
                    signature (written and printed) from the consignee on the
                    delivery receipt as proof of delivery. If the driver learns,
                    sees or becomes aware of cargo loss or damage on the
                    shipment, or the consignee makes written notation of cargo
                    loss, damage or a missing seal on the delivery receipt,
                    Service Provider shall notify the applicable End User
                    immediately by telephone, fax or email. If such discovery of
                    cargo loss, damage or seal discrepancy is made during normal
                    business hours, the driver shall not leave the consignee’s
                    premises until instructed by the applicable End User.
                    Service Provider further acknowledges that its failure to
                    notify the applicable End User immediately of loss or damage
                    may result in the railroad not being allowed a reasonable
                    opportunity to inspect the shipment, and thus, prevent
                    recovery by the End User or the shipper for any such damage.
                    Service Provider shall be liable to KN and the applicable
                    End User for damages incurred due to Service Provider’s
                    failure to notify KN and the applicable End User of cargo
                    loss or damage as outlined above.
                  </span>
                </li>
              </ol>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>Insurance</span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>
                . Service Provider shall furnish KN with Certificate(s) of
                Insurance, or insurance policies providing thirty (30) days
                advance written notice of cancellation or termination, and
                unless otherwise agreed, subject to the following minimum
                limits:
              </span>
              <ol
                className="decimal_type"
                style={{ listStyleType: "undefined" }}
              >
                <li>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    General liability $1,000,000; motor vehicle (including hired
                    and non-owned vehicles) $1,000,000 ($5,000,000 if
                    transporting hazardous materials including environmental
                    damages due to release or discharge of hazardous
                    substances);
                  </span>
                </li>
                <li>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    Cargo damage/loss, $100,000;
                  </span>
                </li>
                <li>
                  <span
                    style={{
                      fontFamily: '"Calibri","sans-serif"',
                      fontSize: "11.0pt",
                    }}
                  >
                    Workers’ compensation with limits required by law.
                  </span>
                </li>
              </ol>
            </li>
          </ol>
        </li>
      </ol>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
          textIndent: "0in",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          Except for the higher coverage limits which may be specified above,
          the insurance policies shall comply with minimum requirements of the
          Federal Motor Carrier Safety Administration and any other applicable
          regulatory state agency. Nothing in this Agreement shall be construed
          to avoid or limit Service Provider’s liability due to any exclusion or
          deductible in any insurance policy. Coverage provided Service
          Provider’s insurance policies shall have no exclusions or restrictions
          of any type that would foreseeably preclude coverage relating to loss
          and damage claims. Service Provider grants permission to KN, and shall
          require its insurance underwriters and agents, to provide KN upon KN’s
          request a copy of all insurance policies including copies of all
          exclusions on any cargo policy. The cargo insurance policy shall not
          exclude coverage for infidelity, fraud, dishonesty, or criminal acts
          of Service Provider, its employees, officers and directors,
          contractors, subcontractors, owner-operators, or agents of Service
          Provider. If any such policy contains those exclusions, Service
          Provider shall obtain and furnish endorsements in the policy providing
          coverage to the satisfaction of KN. No policy of insurance provided to
          KN hereunder shall have a deductible greater than $5,000.
        </span>
      </p>
      <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Prohibited Liens</span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            . Service Provider is strictly prohibited from imposing liens or
            holding freight hostage. Should Service Provider attempt such
            action, KN shall have the right to notify the End User and its
            customer base of Service Provider’s actions.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>
              Service Providers Requirements for Refrigerated Loads
            </span>
          </strong>
          <span style={{ fontSize: "11.0pt" }}>
            . Service Provider agrees that its drivers must:
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Prior to loading, confirm that the reefer unit is working
                properly and the trailer is pre-cooled to the required
                temperature.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Trailers used for transporting produce must have air chute clear
                and in good condition for proper circulation. Make sure the
                chute is not damaged, obstructed or blocked in any way.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Be certain that space is provided for proper air circulation in
                front, rear, top, bottom and between the load.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Check pulp temperature of products to ensure required
                pre-cooling. Driver must not accept any fresh product which
                pulps over 2 degrees (or other agreed amount) above the required
                temperature stated on the End User rate confirmation.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                If the temperature on the End User Rate Confirmation differs
                from that on the Bill of Lading, contact the End User before
                signing the bills of lading at the shipper. If the shipment is
                accepted contrary to the terms of the End User Rate
                Confirmation, Service Provider accepts all resulting risk of
                loss.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Make sure that the pulp temperature documentation of the product
                loaded appears on the original Bill of Lading and agrees with
                that temperature.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                When driver signs the Bill of Lading, such driver is confirming
                that such driver received the correct product, at the correct
                count and at the proper temperature. Be sure this information
                agrees with the information on the Bill of Lading.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Maintain continuous temperature stated on Service Provider’s
                Rate Confirmation in-route, unless otherwise instructed in
                writing by End User.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Notify End User immediately (before leaving receiver/consignee)
                if the shipment is damaged or rejected in whole or in part.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Allows Service Provider time to get USDA inspection.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                No disposition of any rejected product shall be made without
                instructions from End User.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider assumes all risk of loss arising out of any
                failure to follow these directions.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider represents that reefer equipment is and has
                been properly maintained and that it has record (written) proof
                of compliance with manufacturers’ maintenance requirements.
              </span>
            </li>
            <li>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                Service Provider shall comply with the Sanitary Food
                Transportation Act (SFTA) and the FDA Food Safety Modernization
                Act (FSMA).
              </span>
            </li>
          </ol>
        </li>
      </ol>
      <div
        style={{
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "120%",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
        }}
      >
        <ol
          style={{
            marginBottom: "0in",
            listStyleType: "undefined",
            marginLeft: "-0.5in",
          }}
        >
          <li
            style={{
              margin: "0in",
              marginBottom: ".0001pt",
              lineHeight: "120%",
              fontSize: 11,
              fontFamily: '"Verdana","sans-serif"',
            }}
          >
            <span
              style={{
                fontFamily: '"Calibri","sans-serif"',
                fontSize: "11.0pt",
              }}
            >
              LIMITATION OF LIABILITY
            </span>
          </li>
        </ol>
      </div>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "8.0pt",
          marginBottom: "4.0pt",
          textAlign: "justify",
          textIndent: "0in",
          fontWeight: "bold",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
          EITHER PARTY BE LIABLE TO THE OTHER FOR INCIDENTAL, INDIRECT, SPECIAL,
          PUNITIVE OR CONSEQUENTIAL DAMAGES, LOSS OF PROFITS, GOODWILL, DATA OR
          DATA USE ARISING FROM OR IN CONNECTION WITH THIS AGREEMENT, WHETHER
          UNDER THEORY OF CONTRACT, TORT, INCLUDING NEGLIGENCE, OR OTHERWISE,
          EVEN IF A PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          FURTHER,
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          KN
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          WILL NOT BE LIABLE FOR:
        </span>
        <span
          style={{
            fontSize: 15,
            fontFamily: '"Calibri","sans-serif"',
            fontWeight: "normal",
          }}
        >
          (A)
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          SERVICE PROVIDER’S INABILITY TO USE THE PLATFORM, THE EXCHANGE OR THE
          CONTENT, INCLUDING AS A RESULT OF ANY TERMINATION OR SUSPENSION OF
          SERVICE PROVIDER’S ACCOUNTS; OR
        </span>
        <span
          style={{
            fontSize: 15,
            fontFamily: '"Calibri","sans-serif"',
            fontWeight: "normal",
          }}
        >
          (B)
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          THE COST OF PROCUREMENT OF SUBSTITUTE GOODS; OR
        </span>
        <span
          style={{
            fontSize: 15,
            fontFamily: '"Calibri","sans-serif"',
            fontWeight: "normal",
          }}
        >
          (C)
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          ANY INVESTMENTS, EXPENDITURES, OR COMMITMENTS BY SERVICE PROVIDER IN
          CONNECTION WITH THIS AGREEMENT; OR
        </span>
        <span
          style={{
            fontSize: 15,
            fontFamily: '"Calibri","sans-serif"',
            fontWeight: "normal",
          }}
        >
          (D)
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          ANY UNAUTHORIZED ACCESS TO, ALTERATION OF, OR THE DELETION,
          DESTRUCTION, DAMAGE, LOSS OR FAILURE TO STORE ANY SERVICE PROVIDER
          DATA
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          .
        </span>
        <span
          style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
        ></span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          NOTWITHSTANDING ANY OTHER PROVISION IN THIS AGREEMENT,
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          KN’S
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          TOTAL AGGREGATE LIABILITY UNDER THIS AGREEMENT SHALL BE LIMITED TO
          DIRECT DAMAGES CAUSED BY
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          KN
        </span>
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          IN AN AMOUNT NOT TO EXCEED $100.
        </span>
      </p>
      <ol
        className="decimal_type"
        style={{ listStyleType: "undefined", marginLeft: "-0.5in" }}
      >
        <li>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            MISCELLANEOUS PROVISIONS
          </span>
          <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
            <li>
              <strong>
                <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                  Entire Agreement.
                </span>
              </strong>
              <span style={{ fontSize: "11.0pt" }}>This Agreement,</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                including all exhibits, and addendums constitutes
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                the entire
              </span>
              <span style={{ fontSize: "11.0pt" }}>Agreement</span>
              <span style={{ fontSize: "11.0pt" }}>
                between the Parties with respect to the subject matter hereof,
                and
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                supersedes and replaces
              </span>
              <span style={{ fontSize: "11.0pt" }}>
                all prior or contemporaneous understandings or agreements,
                written or oral, regarding such subject matter. No amendment to
                or modification of this Agreement will be binding unless in
                writing and signed or electronically accepted by a duly
                authorized representative of both
              </span>
              <span style={{ fontSize: "11.0pt" }}>Parties. </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                In the case of conflicts, discrepancies, errors or omissions
                among the body of this Agreement, exhibits, and addendums, such
                documents and amendments to them shall take precedence and
                govern in the following order: (a) this Agreement, (b) exhibit,
                and (c) addendum.
              </span>
            </li>
            <li>
              <strong>
                <span style={{ fontSize: "11.0pt" }}>
                  Governing law and Place of Arbitration.
                </span>
              </strong>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                Service Provider’s domicile will determine the
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                KN
              </span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                entity with whom
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                is contracting under this Agreement, what law will apply in any
                dispute arising out of or in connection with this Agreement, the
                place of arbitration for any such dispute, and where Notices to
              </span>
              <span style={{ fontSize: "11.0pt" }}>KN</span>
              <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
                should be directed. Each Party agrees to the applicable
                governing law (without regard to choice or conflicts of law
                rules), and the place of arbitration, corresponding to
              </span>
              <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              >
                ’s domicile as set forth in the chart below. The United Nations
                Convention on Contracts for the International Sale of Goods
                shall not apply to this Agreement or the transactions described
                herein. Each Party hereby waives any right to trial by jury in
                connection with any action or proceeding arising from or related
                to this Agreement.
              </span>
              <span
                style={{
                  fontFamily: '"Calibri","sans-serif"',
                  fontSize: "11.0pt",
                }}
              ></span>
            </li>
          </ol>
        </li>
      </ol>
      <table
        style={{
          marginLeft: "31.65pt",
          borderCollapse: "collapse",
          border: "none",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                width: "93.7pt",
                border: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  Service Provider Domicile
                </strong>
              </p>
            </td>
            <td
              style={{
                width: "86.05pt",
                borderTop: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                borderBottom: "1pt solid windowtext",
                borderImage: "initial",
                borderLeft: "none",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  KN Contracting Party
                </strong>
              </p>
            </td>
            <td
              style={{
                width: "121.5pt",
                borderTop: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                borderBottom: "1pt solid windowtext",
                borderImage: "initial",
                borderLeft: "none",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  Notices to KN
                </strong>
              </p>
            </td>
            <td
              style={{
                width: "85.5pt",
                borderTop: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                borderBottom: "1pt solid windowtext",
                borderImage: "initial",
                borderLeft: "none",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  Governing Law
                </strong>
              </p>
            </td>
            <td
              style={{
                width: "80.75pt",
                borderTop: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                borderBottom: "1pt solid windowtext",
                borderImage: "initial",
                borderLeft: "none",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  Place of Arbitration
                </strong>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "93.7pt",
                borderRight: "1pt solid windowtext",
                borderBottom: "1pt solid windowtext",
                borderLeft: "1pt solid windowtext",
                borderImage: "initial",
                borderTop: "none",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                United States, Mexico, Central America, South America
              </p>
            </td>
            <td
              style={{
                width: "86.05pt",
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                KlearNow, Corp.
              </p>
            </td>
            <td
              style={{
                width: "121.5pt",
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                KlearNow, Corp.
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                [
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  <em>
                    <span style={{ background: "yellow" }}>
                      insert mailing address
                    </span>
                  </em>
                </strong>
                ]
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                Attn.: [<span style={{ background: "yellow" }}>__________</span>
                ]
              </p>
            </td>
            <td
              style={{
                width: "85.5pt",
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                California and
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                United States Federal Law
              </p>
            </td>
            <td
              style={{
                width: "80.75pt",
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                San Francisco, CA, USA
              </p>
            </td>
          </tr>
          <tr>
            <td
              style={{
                width: "93.7pt",
                borderRight: "1pt solid windowtext",
                borderBottom: "1pt solid windowtext",
                borderLeft: "1pt solid windowtext",
                borderImage: "initial",
                borderTop: "none",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                Canada
              </p>
            </td>
            <td
              style={{
                width: "86.05pt",
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                [
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  <em>
                    <span style={{ background: "yellow" }}>
                      insert affiliate, if applicable
                    </span>
                  </em>
                </strong>
                ]
              </p>
            </td>
            <td
              style={{
                width: "121.5pt",
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                [
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  <em>
                    <span style={{ background: "yellow" }}>
                      insert affiliate, if applicable
                    </span>
                  </em>
                </strong>
                ]
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                [
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  <em>
                    <span style={{ background: "yellow" }}>
                      insert mailing address
                    </span>
                  </em>
                </strong>
                ]
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                Attn.: [<span style={{ background: "yellow" }}>__________</span>
                ]
              </p>
            </td>
            <td
              style={{
                width: "85.5pt",
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                [<span style={{ background: "yellow" }}>__________</span>]
              </p>
            </td>
            <td
              style={{
                width: "80.75pt",
                borderTop: "none",
                borderLeft: "none",
                borderBottom: "1pt solid windowtext",
                borderRight: "1pt solid windowtext",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 15,
                  fontFamily: '"Calibri","sans-serif"',
                  margin: "0in",
                  marginBottom: ".0001pt",
                }}
              >
                [<span style={{ background: "yellow" }}>__________</span>]
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          marginTop: "0in",
          marginBottom: "4.0pt",
          textAlign: "justify",
          textIndent: "0in",
        }}
      >
        <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
          <span
            style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
          ></span>
        </strong>
      </p>
      <ol className="decimal_type" style={{ listStyleType: "undefined" }}>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Arbitration.</span>
          </strong>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Any dispute, controversy or claim arising out of or in connection
            with this Agreement, including any question regarding its existence,
            validity or termination, shall be settled by arbitration
            administered by the International Centre for Dispute Resolution in
            accordance with its International Arbitration Rules
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            then in effect. The place and location of arbitration shall be in
            the applicable place of arbitration identified in Section 11.2. In
            each arbitration, there shall be a sole arbitrator mutually selected
            by the Parties. If the Parties are unable to agree on the identity
            of the arbitrator within 30 days of the written demand by a Party to
            submit to arbitration, then the International Centre for Dispute
            Resolution shall select the arbitrator. The language to be used in
            the arbitral proceeding shall be English. The arbitration award
            shall be final and binding on the Parties and judgment on the award
            may be entered in any court of competent jurisdiction. The
            prevailing Party in any arbitration shall be entitled to reasonable
            attorneys’ fees and expenses from the other Party as part of the
            arbitration award. Either Party may request any competent judicial
            or other authority to order any provisional or conservatory measure
            (including any injunction), either prior to the institution of the
            arbitration proceeding or during such proceeding, for the
            preservation of its rights and interests.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Export Laws.</span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider agrees that the applicable export and import laws
            govern Service Provider’s use of the Platform, the Exchange and KN’s
            Content. Service Provider agrees that neither such Content, the
            Platform, the Exchange, nor any direct product thereof will be
            downloaded, exported or re-exported, directly, or indirectly, in
            violation of these laws, or will be used for any purpose prohibited
            by these laws including, without limitation,
          </span>
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            <span
              style={{
                fontFamily: '"Calibri","sans-serif"',
                fontSize: "11.0pt",
              }}
            >
              (i)
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            into any country for which the United States has a trade embargo, or{" "}
            <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
              (ii)
            </strong>{" "}
            to anyone on the U.S. Treasury Department’s list of Specially
            Designated Nationals or the U.S. Commerce Department’s Table of
            Denial Orders.
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            represents and warrants that it is not located in, under the control
            of, or a national or resident of any such country or on any such
            list
          </span>
          <span style={{ fontSize: "11.0pt" }}>.</span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Indemnification by KN</span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>. KN</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            will defend or settle, at its option and expense, any third party
            claim brought against
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            to the extent that it is based on an allegation that
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            use of the Exchange as permitted under this Agreement infringes a
            patent, copyright, or trademark or misappropriates a trade secret of
            any third party (each, a “
            <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
              Service Provider
            </strong>{" "}
            <strong>Claim</strong>”), and, subject to Section 11.6, KN
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}></span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            will pay all damages and costs (including reasonable legal fees)
            finally awarded by a court of final appeal, or pursuant to a
            court-approved settlement thereof, resulting from such
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Claim, provided that
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            (a) promptly gives
          </span>
          <span style={{ fontSize: "11.0pt" }}>KN</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            written notice of the
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Service Provider
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Claim; (b) gives
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            KN
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            sole control of the defense and settlement of the
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Claim (provided that
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            may not settle any
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Claim unless the settlement unconditionally releases
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            of all liability); and (c) provides to
          </span>
          <span style={{ fontSize: "11.0pt" }}>KN</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            all reasonable assistance, at
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            ’s expense. In the event of a
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Claim or if
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            believes the Exchange may infringe or misappropriate,
          </span>
          <span style={{ fontSize: "11.0pt" }}>KN</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            may in its discretion and at no cost to
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            (i) modify the Exchange so that they no longer infringe or
            misappropriate, while retaining substantially equivalent
            functionality, (ii) obtain a license for
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider’s
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            continued use of the Exchange or such Content in accordance with
            this Agreement, or (iii) terminate
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            account. Notwithstanding the foregoing,
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            has no obligation to indemnify, defend or settle a
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Claim to the extent that: (a) the Exchange is altered or modified by
            anyone other than
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            , or used outside the usage and other limitations identified in the
            this Agreement; (b) an infringement claim is based upon any
            software, design, specification, instruction, data or other material
            not furnished by
          </span>
          <span style={{ fontSize: "11.0pt" }}>KN</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            ; or (c) to the extent an infringement claim is based upon the
            combination of the Exchange with any products, data or services not
            provided to
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            by
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            . The foregoing states
          </span>
          <span style={{ fontSize: "11.0pt" }}>KN’s</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            sole liability and
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            exclusive remedy for any type of
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Claim described in this paragraph.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Indemnification b
            </span>
          </strong>
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              y Service Provider
            </span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            . Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            will indemnify, defend, and hold harmless
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            KN and its Affiliates and representatives
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            against any third-party claim (including, without limitation, any
            claim by an End User) made or brought against
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            or its Affiliates or representatives to the extent that (i) it is
            based on an allegation that
          </span>
          <span style={{ fontSize: "11.0pt" }}>the</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Services or
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            development, design, production or marketing of the Services,
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>Data, or</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider’s
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            use of any Content or the Exchange in violation of this Agreement,
            infringes a patent, copyright, or trademark, misappropriates a trade
            secret of any third party or violates the privacy rights of any End
            User, third party, or natural person; (ii)
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            and its Affiliate’s and representative’s use of or access to the
            Exchange causes or results in a data breach, resulting in the
            unauthorized access to or unauthorized acquisition or disclosure of
            personal information or other Confidential Information; (iii) it
            results from
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider’s</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            breach of any representation, warranty or covenant in this
            Agreement; (iv) it results from any violation of law by
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            ; or (v) it results from any dispute between
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            and any End User (each of the matters described in the foregoing
            clauses (i)-(v), a “
            <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
              Claim
            </strong>
            ”), and will indemnify
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            KN and its Affiliates and representatives
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            for all damages and costs (including reasonable legal fees) finally
            awarded by a court of final appeal, or pursuant to a court-approved
            settlement thereof, resulting from such Claim, provided that
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            (a) promptly gives
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            written notice of the Claim; (b) gives
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            sole control of the defense and settlement of the Claim (provided
            that
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            may not settle any Claim unless the settlement unconditionally
            releases
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>KN</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            of all liability and includes no admission of responsibility or
            liability on the part of KN); and (c) provides to
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            all reasonable assistance, at
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Service Provider’s
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            sole expense.
          </span>
          <span style={{ fontSize: "11.0pt" }}></span>
        </li>
        <li>
          <strong>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Release by Service Provider
            </span>
          </strong>
          <span style={{ fontSize: "11.0pt" }}>
            . If Service Provider has a dispute with one or more End Users,
            Service Provider releases KN (and its Affiliates and
            representatives, and its and their respective officers, directors,
            employees and agents) from claims, demands and damages (actual and
            consequential) of every kind and nature, known and unknown, arising
            out of or in any way connected with such disputes. In entering into
            this release you expressly waive any protections (whether statutory
            or otherwise) that would otherwise limit the coverage of this
            release to include only those claims which you may know or suspect
            to exist in your favor at the time of agreeing to this release.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Compliance Audit Rights</span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            . During the term of this Agreement and for a period of seven years
            following its termination, Service Provider shall keep all its
            records relating to Service Provider’s usage of KN’s Content, the
            Platform, the Exchange, and the Services provided by Service
            Provider to each End User and KN may inspect and review Service
            Provider’s records to verify compliance with the grant of rights to
            use such Content and the Exchange, restrictions, and other terms and
            conditions of this Agreement. KN shall provide Service Provider with
            30 days advance written notice of such compliance check. Service
            Provider agrees to cooperate with the compliance check, and provide
            KN with reasonable assistance and access to information. Any such
            audit will be performed at KN’s expense, provided, however, that
            Service Provider shall promptly reimburse KN for the cost of such
            audit and any applicable fees if such audit reveals any material
            violation of this Agreement.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Notices.</span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>An</span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            y notice, consent, approval, or other communication intended to have
            legal effect to be given under this Agreement (“
            <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
              Notices
            </strong>
            ”) must be in writing and shall be deemed to be have been given
            upon:
          </span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            (i) personal delivery, (ii) the second business day after mailing,
            (iii) the second business day after sending by confirmed facsimile,
            or (iv) the first business day after sending by email (provided that
            email shall not be sufficient alone for notices of termination or
            claims for indemnification). All Notices to
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            will be addressed to the system administrator designated by
          </span>
          <span style={{ fontSize: "11.0pt" }}>Service Provider</span>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            on its account.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Relationship of Parties</span>
          </strong>
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            <span style={{ fontSize: "11.0pt" }}>.</span>
          </strong>
          <span style={{ fontSize: "11.0pt" }}>
            The Parties are independent contractors, and not agents, employees
            or joint ventures of one another, and do not have any authority to
            bind the other Party by contract or otherwise to any obligation.
            Neither Party will represent to the contrary, either expressly,
            implicitly, by appearance or otherwise.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              No Third-Party Beneficiaries.
            </span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Except as expressly set forth herein, thereare no third-party
            beneficiaries to this Agreement.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Assignment</span>
          </strong>
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>.</span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            This Agreement (including each Party’s rights and obligations) is
            not assignable or transferable by either Party without the prior
            written consent of the other Party, which shall not be unreasonably
            withheld. Any attempt by either Party to assign or transfer this
            Agreement without such consent shall be void. Notwithstanding the
            foregoing, either Party may assign or transfer this Agreement in its
            entirety to its Affiliate or as a result of a merger, acquisition,
            corporate reorganization, or a sale of all or substantially all of
            its assets not involving a direct competitor of the other Party. In
            the case of any permitted assignment or transfer of or under this
            Agreement, this Agreement or the relevant provisions shall be
            binding upon, and inure to the benefit of, the successors,
            executors, heirs, representatives, administrators and assigns of the
            Parties hereto. Notwithstanding the foregoing, if a Party is
            acquired by, sells a substantial part of its assets, or undergoes a
            change of control in favor of, a direct competitor of the other
            Party or otherwise breaches this paragraph, then such other Party
            may terminate this Agreement upon written notice.
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            Subjecttotheforegoing,thisAgreementshallbindandinuretothebenefitof
            theParties,theirrespectivesuccessorsandpermittedassigns.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Severability</span>
          </strong>
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>.</span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            If any provision of this Agreement is unlawful, void or for any
            reason declared unenforceable by any court of competent
            jurisdiction, that provision shall be deemed severable from, and
            shall in no way effect the validity or enforceability of, the
            remaining provisions
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>.</span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>Force Majeure</span>
          </strong>
          <span style={{ fontSize: "11.0pt" }}>
            . No Party shall be liable for, or considered to be in breach of
            this Agreement on account of, any failure or delay in performance of
            any of its obligations hereunder (except for the payment of money)
            if such failure or delay is due to acts of God, fires, flood, storm,
            explosions, earthquakes, general Internet outages, acts of war or
            terrorism, riots, insurrection, intervention of any government or
            authority or any other reason where the failure to perform is beyond
            the reasonable control of and not caused by the negligence or
            intentional acts or omissions of the non-performing Party.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontSize: "11.0pt" }}>No Waiver of Rights</span>
          </strong>
          <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
            <span style={{ fontSize: "11.0pt" }}>; Cumulative Remedies.</span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            The failure of either Party to enforce any of the provisions of this
            Agreement, or the failure to require performance by the other Party
            of any of the provisions of this Agreement, shall not be construed
            to be a present or future waiver of such provisions, nor affect the
            validity of either Party’s right to enforce such provision in
            future. The remedies provided in this Agreement are in addition to
            any other remedies at law or in equity, except as expressly provided
            otherwise herein.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Survival.
            </span>
          </strong>
          <span
            style={{ fontFamily: '"Calibri","sans-serif"', fontSize: "11.0pt" }}
          >
            Sections
          </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>3.3</span>
          <span style={{ fontSize: "11.0pt" }}>(“Restrictions of Use”),</span>
          <span style={{ fontSize: "11.0pt" }}>4</span>
          <span style={{ fontSize: "11.0pt" }}>
            (“Intellectual Property Rights, Ownership and Title”),
          </span>
          <span style={{ fontSize: "11.0pt" }}>5</span>
          <span style={{ fontSize: "11.0pt" }}>(“Confidentiality”),</span>
          <span style={{ fontSize: "11.0pt" }}>8.3</span>
          <span style={{ fontSize: "11.0pt" }}>
            (“Disclaimer of Warranties”), 8 (“Warranties”), 9 (“Service Provider
            Responsibilities”) 10 (“Limitation of Liability”), and 11
            (“Miscellaneous Provisions”) of this Agreement shall survive
            termination, without prejudice to other obligations that, pursuant
            to the applicable law or to this Agreement, shall also remain in
            force after the termination date.
          </span>
        </li>
        <li>
          <strong>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              Government Brokers
            </span>
          </strong>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>. </span>
          <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
            As defined in FAR section 2.101, DFAR section 252.227-7014(a)(1) and
            DFAR section 252.227-7014(a)(5) or otherwise, the software and other
            Content provided in connection with this Agreement are “commercial
            items,” “commercial computer software” and/or “commercial computer
            software documentation.” Consistent with DFAR section 227.7202, FAR
            section 12.212 and other sections, any use, modification,
            reproduction, release, performance, display, disclosure or
            distribution thereof by or for the U.S. Government shall be governed
            solely by the terms of this Agreement and shall be prohibited except
            to the extent expressly permitted by the terms of this Agreement.
            Any technical data provided that is not covered by the above
            provisions shall be deemed “technical data-commercial items”
            pursuant to DFAR section 227.7015(a). Any use, modification,
            reproduction, release, performance, display or disclosure of such
            technical data shall be governed by the terms of DFAR section
            227.7015(b).
          </span>
        </li>
      </ol>
      <div
        style={{
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "120%",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
        }}
      >
        <ol
          style={{
            marginBottom: "0in",
            listStyleType: "undefined",
            marginLeft: "-0.5in",
          }}
        >
          <li
            style={{
              margin: "0in",
              marginBottom: ".0001pt",
              lineHeight: "120%",
              fontSize: 11,
              fontFamily: '"Verdana","sans-serif"',
            }}
          >
            <span
              style={{
                fontFamily: '"Calibri","sans-serif"',
                fontSize: "11.0pt",
              }}
            >
              Country Specific Provisions and Exceptions.
            </span>
            <span style={{ fontSize: "11.0pt" }}>
              The Country Addendum contains specific provisions and exceptions
              that apply to the CONTENT, the platform and the EXCHANGE in
            </span>
            <span style={{ fontFamily: '"Calibri","sans-serif"' }}>
              certain jurisdictions depending on service provider’s domicile and
              the applicable governing law and KN entity who is a party to this
              Agreement pursuant to Section 11.2. To the extent that (i) the
              provisions of the Country Addendum apply and (ii) such provisions
              conflict with the other terms and conditions of the body of this
              Agreement, the provisions of the Country Addendum will control.
              <span style={{ verticalAlign: "super" }}></span>
            </span>
          </li>
        </ol>
      </div>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "120%",
        }}
      >
        <span
          style={{
            fontSize: 15,
            lineHeight: "120%",
            fontFamily: '"Calibri","sans-serif"',
          }}
        ></span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 13,
          fontFamily: '"Arial","sans-serif"',
          marginTop: "0in",
          marginBottom: "6.0pt",
          textAlign: "justify",
        }}
      >
        <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
          IN WITNESS WHEREOF, the Parties have executed this Agreement as of the
          date first written above.
        </span>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 13,
          fontFamily: '"Arial","sans-serif"',
          marginTop: "0in",
          marginBottom: "6.0pt",
          textAlign: "justify",
        }}
      >
        <span
          style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
        ></span>
      </p>
      <table style={{ border: "none", borderCollapse: "collapse" }}>
        <tbody>
          <tr>
            <td
              style={{
                width: "3.75in",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  <span
                    style={{
                      fontSize: 15,
                      fontFamily: '"Calibri","sans-serif"',
                    }}
                  >
                    Service Provider:
                  </span>
                </strong>
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                >
                  [
                  <span style={{ background: "yellow" }}>
                    Insert name of company
                  </span>
                  ]
                </span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                ></span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                >
                  By:
                  <u></u>
                </span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                >
                  Name:
                </span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                >
                  Title:
                </span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                ></span>
              </p>
            </td>
            <td
              style={{
                width: "3.75in",
                padding: "0in 5.4pt",
                verticalAlign: "top",
              }}
            >
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
                  <span
                    style={{
                      fontSize: 15,
                      fontFamily: '"Calibri","sans-serif"',
                    }}
                  >
                    KN:
                  </span>
                </strong>
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                >
                  [
                  <span style={{ background: "yellow" }}>
                    Insert appropriate KlearNow Entity
                  </span>
                  ]
                </span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                ></span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                >
                  By:
                  <u></u>
                </span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                >
                  Name:
                </span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                >
                  Title:
                </span>
              </p>
              <p
                style={{
                  marginRight: "0in",
                  marginLeft: "0in",
                  fontSize: 13,
                  fontFamily: '"Arial","sans-serif"',
                  marginTop: "0in",
                  marginBottom: "6.0pt",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}
                ></span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        <br />
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "normal",
          textAlign: "center",
        }}
      >
        <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
          <span style={{ fontSize: 15, fontFamily: '"Calibri","sans-serif"' }}>
            EXHIBIT A
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "120%",
          textAlign: "center",
        }}
      >
        <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
          <span
            style={{
              fontSize: 15,
              lineHeight: "120%",
              fontFamily: '"Calibri","sans-serif"',
            }}
          ></span>
        </strong>
      </p>
      <p
        style={{
          marginRight: "0in",
          marginLeft: "0in",
          fontSize: 11,
          fontFamily: '"Verdana","sans-serif"',
          margin: "0in",
          marginBottom: ".0001pt",
          lineHeight: "120%",
          textAlign: "center",
        }}
      >
        <strong style={{ fontFamily: '"Times New Roman","serif"' }}>
          <span
            style={{
              fontSize: 15,
              lineHeight: "120%",
              fontFamily: '"Calibri","sans-serif"',
            }}
          >
            Branding and Trademark Usage Guidelines
          </span>
        </strong>
      </p>
    </div>
  );
};

export default TOS;
